var _defs, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCartIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14.71 16.25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".d{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "b"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M3.49,13.92c-.64,0-1.16,.52-1.16,1.16s.52,1.16,1.16,1.16,1.16-.52,1.16-1.16-.52-1.16-1.16-1.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M9.32,13.92c-.64,0-1.16,.52-1.16,1.16s.52,1.16,1.16,1.16,1.16-.52,1.16-1.16-.52-1.16-1.16-1.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M8.48,11.01c.42,0,.82-.23,1.02-.6l1.11-2.01c-1.73-.08-3.21-1.13-3.89-2.63H2.45l-.55-1.16H0v1.16H1.16l2.1,4.42-.79,1.42c-.31,.56-.1,1.27,.46,1.59,.17,.09,.37,.14,.56,.14h6.99v-1.16H3.49l.64-1.16h4.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M10.82,0c-2.15,0-3.88,1.74-3.88,3.88,0,.69,.17,1.33,.49,1.89,.66,1.19,1.93,1.99,3.39,1.99,.05,0,.09,0,.14,0,2.08-.07,3.75-1.77,3.75-3.88s-1.74-3.88-3.88-3.88Zm2.44,4.53h-1.79v1.79h-1.29v-1.79h-1.79v-1.29h1.79V1.44h1.29v1.79h1.79v1.29Z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCartIcon);
export default __webpack_public_path__ + "static/media/cartIcon.7fb7f0290e8d8bc4cb8d263c89866d24.svg";
export { ForwardRef as ReactComponent };